export default __webpack_public_path__ + "static/media/invalid_icon.34555573.svg";